import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MyharrellsService } from '../myharrells.service';


@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.css'
})
export class CartComponent {

  constructor(public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute,) { }

  custNmbr: string = "";
  custName: string = "";
  custAddress: string = "";
  // itemsInCart: any[] = [];
  cartArray: any[] = [];
  notes: string = "";
  deliveryDate: string = "";
  deliveryMessage: string = "";
  po: string = "";
  grandTotal: number = 0;

  disableSubmit: boolean = false;

  productPhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/ProductPhotos/";

  ngOnInit(): void {

    //check if sessionstorage is defined loggedInMyHarrellsUser
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('CustomerNumberSelected')) {
      this.custNmbr = sessionStorage.getItem('CustomerNumberSelected');
    }
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('CustomerNameSelected')) {
      this.custName = sessionStorage.getItem('CustomerNameSelected');
    }
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('PartnershipCustomerAddressSelected')) {
      this.custAddress = sessionStorage.getItem('PartnershipCustomerAddressSelected');
    }

    this.myHarrellsService.onlineOrderingInEffect = true


    this.GetExistingDraftDetails().then(() => {
      //default delivery datew to 3 days from today 
      if (this.deliveryDate == "" || this.deliveryDate == '1/1/1900 12:00:00 AM') {
        let today = new Date();
        let deliveryDate = new Date();
        deliveryDate.setDate(today.getDate() + 3);
        let month = '0' + (deliveryDate.getMonth() + 1).toString();
        let day = '0' + deliveryDate.getDate();
        this.deliveryDate = deliveryDate.getFullYear() + '-' + month.slice(-2) + '-' + day.slice(-2);
      }

      //if delivery message is empty, default it
      if (this.deliveryMessage == "") {
        this.deliveryMessage = "On or Before";
      }
    });

    this.FillItemGrid();
  }


  GetExistingDraftDetails() {
    return new Promise((resolve, reject) => {
      this.dotComService.GetDraftDetails(this.custNmbr, sessionStorage.getItem('PartnershipCustomerAddressCodeselected')).subscribe((response: any) => {
        if (response.length > 0) {
          this.notes = response[0].Notes;
          if (response[0].DeliveryDate != '1/1/1900 12:00:00 AM') {
            let month = '0' + (new Date(response[0].DeliveryDate).getMonth() + 1).toString();
            let day = '0' + new Date(response[0].DeliveryDate).getDate();
            this.deliveryDate = new Date(response[0].DeliveryDate).getFullYear() + '-' + month.slice(-2) + '-' + day.slice(-2);
            this.deliveryMessage = response[0].DispatchNotes;
          }
          // this.deliveryMessage = response[0].DeliveryMessage;
          this.po = response[0].PO;

          //if we dont have a shopping cart in session storage but we do in sql server, 
          //then we need to add shopping cart in session storage
          //this is only needed if the user is taken to the cart page directly from the myharrells page
          //or the cart icon in the header
          if (sessionStorage.getItem('ShoppingCart') == null) {
            sessionStorage.setItem('ShoppingCart', JSON.stringify(sessionStorage.getItem('ShoppingCart')));
          }
          resolve('');
        }
        else {
          resolve('');
        }
      })
    })
  }

  FillItemGrid() {
    //this.itemsInCart = [];
    let cart = sessionStorage.getItem('ShoppingCart');
    this.cartArray = JSON.parse(cart);
    this.grandTotal = 0;

    for (let i = 0; i < this.cartArray.length; i++) {
      //adding the image object to the array
      this.cartArray[i].ImageURL = this.productPhotosImagePaths + this.cartArray[i].itemNmbr + ".jpg";
      //add the total price to the array
      this.cartArray[i].TotalPrice = (this.cartArray[i].qty * this.cartArray[i].priceEach).toFixed(2);
      this.grandTotal += parseFloat(this.cartArray[i].TotalPrice);


    }
  }

  DeleteItem(item: any) {
    let cart = sessionStorage.getItem('ShoppingCart');
    let cartArray = JSON.parse(cart);
    let index = cartArray.findIndex((x: any) => x.itemNmbr == item.itemNmbr);
    cartArray.splice(index, 1);
    sessionStorage.setItem('ShoppingCart', JSON.stringify(cartArray));
    this.dotComService.cartCount = this.dotComService.cartCount - 1;
    this.FillItemGrid();
    //add/update order draft stored in sql server
    this.dotComService.AddUpdateDraft('dnc', 'dnc', 'dnc', 'draft', 'dnc').subscribe((response: any) => {
    })



  }

  UpdateItemQty(e: any, item) {
    this.disableSubmit = false;

    //if in eop mode, check to see the new qty does not exceed the max qty
    if (sessionStorage.getItem('EOPMode') == 'true') {

      let QtyByItemArray = JSON.parse(sessionStorage.getItem('QtyByItemMax'));
      let availableToOrder = QtyByItemArray.filter(x => x.ItemNmbr == item.itemNmbr)[0].QtyTotal;


      if (parseInt(e.target.value) > availableToOrder) {
        this.disableSubmit = true;
        this.dotComService.warningText = "<b>Quantity Exceeded</b>  The quantity you entered exceeds the maximum quantity allowed (" + availableToOrder + ") for this item.  Please adjust and try again.";
        this.dotComService.displayWarning = true;
        //hide the message automatically
        setTimeout(function () {
          this.dotComService.displayWarning = false;
          this.dotComService.warningText = "";
        }.bind(this), 2000);
        return;
      }
    }



    let cart = sessionStorage.getItem('ShoppingCart');
    let cartArray = JSON.parse(cart);
    let index = cartArray.findIndex((x: any) => x.itemNmbr == item.itemNmbr);
    cartArray[index].qty = parseInt(e.target.value);
    cartArray[index].TotalPrice = (cartArray[index].qty * cartArray[index].priceEach).toFixed(2);
    sessionStorage.setItem('ShoppingCart', JSON.stringify(cartArray));
    this.FillItemGrid();
    this.dotComService.AddUpdateDraft(this.notes, this.deliveryDate, this.po, 'draft', this.deliveryMessage).subscribe((response: any) => {

    })
  }

  UpdateNotesPODelDate(event: any) {
    this.dotComService.AddUpdateDraft(this.notes, this.deliveryDate, this.po, 'draft', this.deliveryMessage).subscribe((response: any) => {
    })
  }

  ContinueShopping() {
    this.router.navigate(['/products']);
  }

  StartOver() {
    //delete the draft and remove the cart from session storage
    this.dotComService.DeleteDraftOrder().subscribe((response: any) => {
      sessionStorage.removeItem('ShoppingCart');
      this.dotComService.cartCount = 0;
      this.dotComService.DeleteDraftOrder().subscribe((response: any) => { })
      //this.dotComService.AddUpdateDraft('dnc', 'dnc', 'dnc', 'delete', 'dnc').subscribe((response: any) => {
      // })
      this.router.navigate(['/products']);
    })
  }

  SubmitOrder() {
    //validate
    this.dotComService.displaySuccess = false;
    this.dotComService.successText = "";
    this.dotComService.displayWarning = false;
    this.dotComService.warningText = "";


    if (this.deliveryDate == "" || this.deliveryDate == '1/1/1900 12:00:00 AM') {

      this.dotComService.warningText = "<b>Delivery Date is required.</b>  Please supply a delivery Date and try again.";
      this.dotComService.displayWarning = true;
      //hide the message automatically
      setTimeout(function () {
        this.dotComService.displayWarning = false;
        this.dotComService.warningText = "";
      }.bind(this), 2000);
      return;
    }
    if (this.po == "" && sessionStorage.getItem('CustomerPORequired') == 'true') {
      this.dotComService.warningText = "<b>Purchase Order is required.</b>  Please supply a Purchase Order and try again.";
      this.dotComService.displayWarning = true;
      //hide the message automatically
      setTimeout(function () {
        this.dotComService.displayWarning = false;
        this.dotComService.warningText = "";
      }.bind(this), 2000);
      return;
    }
    if (this.dotComService.cartCount == 0) {
      this.dotComService.warningText = "<b>Cart is empty.</b>  Please add items to your cart and try again.";
      this.dotComService.displayWarning = true;
      //hide the message automatically
      setTimeout(function () {
        this.dotComService.displayWarning = false;
        this.dotComService.warningText = "";
      }.bind(this), 2000);
      return;
    }

    this.dotComService.ShowSpinnerModal()

    if (sessionStorage.getItem('EOPMode') == 'true') {
      //eop fullfillment 

      // //make sure the zzitemnumber is filled in for each item in the cart
      // let cart = sessionStorage.getItem('ShoppingCart');
      // let cartArray = JSON.parse(cart);
      // for (let i = 0; i < cartArray.length; i++) {
      //   if (cartArray[i].zzItemNumber == null || cartArray[i].zzItemNumber == "") {
      //     cartArray[i].zzItemNmbr = 'ZZ' + cartArray[i].itemNmbr;
      //   }
      //   if (i == cartArray.length - 1) {
      //     sessionStorage.setItem('ShoppingCart', JSON.stringify(cartArray));
      //   }
      // }

      //place the order
      this.myHarrellsService.PlaceEOPFullfillmentRequest(this.deliveryDate, this.po, this.notes, this.deliveryMessage).subscribe((response: any) => {
        if (response == true) {
          this.myHarrellsService.UpdateOnlineOrderStatusToSubmitted().subscribe((status: any) => {
            sessionStorage.removeItem('ShoppingCart');
            this.dotComService.cartCount = 0;
            this.myHarrellsService.onlineOrderingInEffect = false;
            this.dotComService.successText = "<b>Order Submitted!</b>";
            this.dotComService.displaySuccess = true;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/myharrells']);
            })
            //hide the message automatically
            setTimeout(function () {
              this.dotComService.displaySuccess = false;
              this.dotComService.successText = "";
              this.dotComService.HideSpinnerModal()
            }.bind(this), 4000);
          })
        }
        else {
          this.dotComService.warningText = "<b>Problem Submitting Your Order</b> Please conact Harrell's Support for assistance.";
          this.dotComService.displayWarning = true;
          this.dotComService.HideSpinnerModal()
        }
      })


    }
    else {
      //olo
      this.myHarrellsService.GetRepInfo(sessionStorage.getItem('PartnerSalesPersonId')).subscribe((data: any) => {
        if (data.length > 0) {
          let harrellsId = data[0].HarrellsId;
          this.myHarrellsService.PlaceOnlineOrder(harrellsId, this.deliveryDate, this.po, this.notes, this.deliveryMessage).subscribe((response: any) => {
            if (response == true) {
              this.myHarrellsService.UpdateOnlineOrderStatusToSubmitted().subscribe((status: any) => {
                sessionStorage.removeItem('ShoppingCart');
                this.dotComService.cartCount = 0;
                this.myHarrellsService.onlineOrderingInEffect = false;
                this.dotComService.successText = "<b>Order Submitted!</b>";
                this.dotComService.displaySuccess = true;

                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['/myharrells']);
                })
                //hide the message automatically
                setTimeout(function () {
                  this.dotComService.displaySuccess = false;
                  this.dotComService.successText = "";
                  this.dotComService.HideSpinnerModal()
                }.bind(this), 4000);
              })
            }
            else {
              this.dotComService.warningText = "<b>Problem Submitting Your Order</b> Please conact Harrell's Support for assistance.";
              this.dotComService.displayWarning = true;
              this.dotComService.HideSpinnerModal()
            }
          })
        }
        else {
          this.dotComService.HideSpinnerModal()
        }
      })
    }
  }
}
